<template>
  <Cfg>
    <slot>
      <div class="animated fadeIn">
        <Alerts ref="alert" />
        <Forms ref="frmGroup"
          :title="this.$lang.Product.TitleForm"
          :showHelp="true"
          :showClearButton="true"
          :showSaveButton="true"
          v-on:Clear="onClear"
          v-on:Save="onSave"
          >
          <div class="form-group row">
            <div class="col-md-3">
              <label for="txtProductName"><small class="text-danger">*</small> {{$lang.Product.LabelName}}:</label>
              <div class="input-group">
                <b-form-input
                  type="text"
                  name="txtProductName"
                  :placeholder="$lang.Product.PlaceholderEnterName"
                  v-model="form.name.value"
                  :size="form.name.maxlength"
                  :required="form.name.required"
                  :state="form.name.state">
                </b-form-input>
              </div>
            </div>
            <div class="col-md-6">
              <label for="cbxInsurance"><small class="text-danger" v-show="form.insuranceID.required">*</small> {{$lang.Product.LabelInsurance}}:</label>
              <div class="input-group">
                <b-form-select
                  v-model="form.insuranceID.value"
                  :options="form.insuranceID.options"
                  :state="form.insuranceID.state"
                  class="mb-3"
                  name="cbxInsurance"
                  @input="onChangeInsurance"
                  >
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-3">
              <label for="cbxBusinessType"><small class="text-danger" v-show="form.businessTypeID.required">*</small>
                {{$lang.Product.LabelBusinessType}}:</label>
              <div class="input-group">
                <b-form-select
                  v-model="form.businessTypeID.value"
                  :options="form.businessTypeID.options"
                  :state="form.businessTypeID.state"
                  class="mb-3"
                  name="cbxBusinessType">
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <label for="txtNote"><small class="text-danger" v-show="form.note.required">*</small> {{$lang.Product.LabelNote}}:</label>
              <div class="input-group">
                <b-form-textarea
                  type="text"
                  rows="4"
                  name="txtNote"
                  :placeholder="$lang.Product.PlaceholderEnterNote"
                  v-model="form.note.value"
                  :size="form.note.maxlength"
                  :required="form.note.required"
                  :state="form.note.state">
                </b-form-textarea>
              </div>
            </div>
          </div>
          <br />
          <div class="form-group row">
            <div class="col-md-4">
              <label for="cbxFieldRule"><small class="text-danger" v-show="form.fieldRule.required">*</small>
                {{$lang.Product.FieldRule}}:</label>
              <div class="input-group">
                <b-form-select
                  v-model="form.fieldRule.value"
                  :options="form.fieldRule.options"
                  :state="form.fieldRule.state"
                  class="mb-3"
                  name="cbxFieldRule">
                  <template slot="first">
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                    <option value="sinistercode">Código do Sinistro</option>
                    <option value="cnpj">CNPJ</option>
                  </template>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-4">
              <label for="cbxTypeRule"><small class="text-danger" v-show="form.typeRule.required">*</small>
                {{$lang.Product.TypeRule}}:</label>
              <div class="input-group">
                <b-form-select
                  v-model="form.typeRule.value"
                  :options="form.typeRule.options"
                  :state="form.typeRule.state"
                  class="mb-3"
                  name="cbxTypeRule">
                  <template slot="first">
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                    <option :value="0">Igual</option>
                    <option :value="1">Começa com</option>
                    <option :value="2">Contém</option>
                  </template>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-4">
              <label for="cbxValueRule"><small class="text-danger" v-show="form.valueRule.required">*</small>
                {{$lang.Product.ValueRule}}:</label>
              <div class="input-group">
                <b-form-input
                  type="text"
                  name="txtValueRule"
                  :placeholder="$lang.Product.PlaceholderEnterName"
                  v-model="form.valueRule.value"
                  :size="form.valueRule.maxlength"
                  :required="form.valueRule.required"
                  :state="form.valueRule.state">
                </b-form-input>
              </div>
            </div>
          </div>
        </Forms>
        <Tables ref="tableGrid"
          :columns="[$lang.Product.DataTable.Name,
                    $lang.Product.DataTable.BusinessType,
                    $lang.Product.DataTable.Insurance,
                    $lang.Common.DataTable.Status,
                    $lang.Common.DataTable.ActionDate,
                    $lang.Common.DataTable.AccountAction,
                    $lang.Common.DataTable.Actions]"
          :showSearch="false"
          :showPrint="true"
          :showDownload="false"
          :showFullscreen="false"
          v-on:Load="onLoad">
          <tr v-for="obj in this.objList" v-bind:key="obj.id">
            <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.name" />
            <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.businessType.name" />
            <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.insurance.name" />
            <TableColumn :IsStatus="true" v-on:Edit="onEdit(obj)" :status="obj.status" />
            <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dateUpdate" />
            <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.accountUserNameUpdate" />
            <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
          </tr>
        </Tables>
      </div>
    </slot>
  </Cfg>
</template>

<script>
import Product from './product.js'

export default Product
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/product/product.vue